import { Box, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useEffect, useState } from 'react';
import contractor from '../../../assets/contractor.png';
import { withFirebase } from '../../Firebase';

function UnstyledButtonCustom({ title, icon, phone, onClick, ...props }) {
   const [iconUrl, setIconUrl] = useState(null);
   const number = phone?.trim();
   useEffect(() => {
      let cancelled = false;
      setIconUrl(null);

      if (icon && props.firebase) {
         if (icon === 'contractor') {
            setIconUrl(contractor);
         } else {
            const fullPath = props.firebase.showImage(icon);
            fullPath
               .getDownloadURL()
               .then((url) => {
                  if (!cancelled) setIconUrl(url);
               })
               .catch(() => {
                  if (!cancelled) setIconUrl(null);
               });
         }
      }

      return () => {
         cancelled = true;
      };
   }, [icon, props.firebase]);

   return (
      <Button
         variant="outlined"
         sx={{
            width: 250,
            height: 180,
            backgroundColor: '#fff',
            mt: 1.5,
            mx: 1,
            p: 0,
            overflow: 'hidden',
            flexDirection: 'column',
            borderRadius: 2,
            '&:hover': { backgroundColor: '#f0f0f0' },
         }}
         onClick={onClick}
      >
         <Box
            sx={{
               flex: 1,
               minHeight: 0,
               width: '100%',
               display: 'flex',
               flexDirection: 'column',
               justifyContent: 'center',
               px: 1.5,
               pt: 1,
               pb: number ? 1 : 1.5,
            }}
         >
            {iconUrl !== null && (
               <Box
                  sx={{
                     flex: 1,
                     minHeight: 0,
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                  }}
               >
                  <img
                     style={{
                        maxWidth: '100%',
                        maxHeight: '52px',
                        width: 'auto',
                        height: 'auto',
                     }}
                     src={iconUrl}
                     alt=""
                  />
               </Box>
            )}
            <Box sx={{ fontSize: 'medium', lineHeight: 1.25 }}>{title}</Box>
         </Box>
         {/* Tenants add their number in their own visitor settings; no number, no band. */}
         {number && (
            <Box
               sx={{
                  width: '100%',
                  py: 0.75,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  backgroundColor: 'grey.100',
                  borderTop: '1px solid',
                  borderColor: 'divider',
                  color: 'text.primary',
                  fontSize: '1.25rem',
                  fontWeight: 700,
                  letterSpacing: '0.04em',
                  fontVariantNumeric: 'tabular-nums',
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
               }}
            >
               <PhoneIcon sx={{ fontSize: '1em', color: 'primary.main' }} />
               {number}
            </Box>
         )}
      </Button>
   );
}

export default withFirebase(UnstyledButtonCustom);
